module.exports = (__webpack_require__(70))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/worker/web_client/JobStatus.js from dll-reference girder_plugin_worker
// module id = 67
// module chunks = 0